export default __webpack_public_path__ + "static/media/hm-ag-img.64dedf41.webp";